module.exports = __webpack_public_path__ + "img/7.258c70d0.png";